var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SingleDayGraph"},[(_vm.isGraphDataAvailable)?_c('div',{ref:"singleDay",staticStyle:{"width":"100%","height":"400px","overflow":"hidden"}}):_c('div',[_c('h3',{staticStyle:{"text-align":"center","padding-top":"50px"}},[_vm._v("No Data Found")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }